<template>
  <div>
	<el-select class="city" v-model="address.provinceId" filterable placeholder="请选择省" @change="changeProvince">
		<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id" />
	</el-select>
	<el-select class="city" v-model="address.cityId" filterable placeholder="请选择市" @change="changeCity">
		<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id" />
	</el-select>
	<el-input class="address" v-model="address.address" placeholder="请输入详细地址" />
  </div>
</template>
<script>
import AreaService from '@/services/area';
export default {
    data() {
		return {
			address: {
				provinceId: '',
				cityId: '',
				address: ''
			},
			cityList: [],
			provinceList: []
		};
    },
	created() {},
	mounted() {
		this.initArea('province', '0');
	},
    methods: {
		// 查询对应的城市
		changeProvince(ev) {
			if (ev) this.initArea('city', ev);
			this.$emit('changeCity', ev)
			this.address.cityId = '';
			this.cityList = [];
		},
		async initArea (type, pid) {
			const { code, message, result } = await AreaService.areaByParentIdApi(pid);
			if (Object.is(code, 0)) {
				this[`${type}List`] = result;
			} else {
				console.error(`获取${type}失败`, message);
			}
		},
		changeCity(ev) {
			this.$emit('changeCityId', ev)
		}
	}
  };

</script>

<style lang="scss" scoped>
.city{
	margin-right: 8px
}
.address{
	margin-top: 10px
}
</style>
